import * as FlightDetails from './seat-map/ui/FlightDetails/FlightDetails.css';
import * as AirplaneName from './seat-map/ui/FlightDetails/ui/AirplaneName/AirplaneName.css';
import * as AirplaneOption from './seat-map/ui/FlightDetails/ui/AirplaneOption/AirplaneOption.css';
import * as Passenger from './seat-map/ui/Passenger/Passenger.css';
import * as FilterItem from './seat-map/ui/FilterItem/FilterItem.css';
import * as SeatInfo from './seat-map/ui/SeatInfo/SeatInfo.css';
import * as SeatsList from './seat-map/ui/SeatsList/SeatsList.css';
import * as FareGroupV2 from './fare/ui/FareGroupV2/FareGroupV2.css';
import * as GridOptions from './fare/ui/FareGroupV2/components/GridOptions/GridOptions.css';
import * as GridOption from './fare/ui/FareGroupV2/components/GridOption/GridOption.css';
import * as ListOptions from './fare/ui/FareGroupV2/components/ListOptions/ListOptions.css';
import * as ListOption from './fare/ui/FareGroupV2/components/ListOption/ListOption.css';
import * as Header from './fare/ui/FareGroupV2/components/Header/Header.css';
import * as FooterLinks from './fare/ui/FareGroupV2/components/FooterLinks/FooterLinks.css';
import * as RecommendedBadge from './fare/ui/FareGroupV2/components/RecommendedBadge/RecommendedBadge.css';
import * as Upgrade from './fare/ui/FareGroupV2/components/Upgrade/Upgrade.css';
import * as Taxes from './fare/ui/FareGroupV2/components/Taxes/Taxes.css';
import * as FareButton from './fare/ui/FareGroupV2/components/FareButton/FareButton.css';
import * as FfpBonusInfoBlock from './fare/ui/FareGroupV2/components/FfpBonusInfoBlock/FfpBonusInfoBlock.css';
import * as TaxesCollapse from './fare/ui/TaxesCollapse/TaxesCollapse.css';
import * as TaxesDetails from './fare/ui/TaxesDetails/TaxesDetails.css';
import * as TaxesTooltip from './fare/ui/TaxesTooltip/TaxesTooltip.css';
import * as Payment from './payment/ui/PaymentResult/PaymentResult.css';
import * as PassTitle from './passengers/ui/PassTitle/PassTitle.css';
import Restrictions from './restrictions/ui/theme';
import Order from './order/ui/theme';
import Refund from './refund/ui/theme';
export default {
    Payment,
    SeatMap: {
        Passenger,
        AirplaneName,
        AirplaneOption,
        FlightDetails,
        FilterItem,
        SeatInfo,
        SeatsList
    },
    FareGroupV2: {
        FareGroupV2,
        GridOptions,
        GridOption,
        ListOptions,
        ListOption,
        Header,
        FooterLinks,
        RecommendedBadge,
        Upgrade,
        Taxes,
        FareButton,
        FfpBonusInfoBlock
    },
    Fare: {
        TaxesCollapse,
        TaxesDetails,
        TaxesTooltip
    },
    Passenger: { PassTitle },
    Restrictions,
    Order,
    Refund
};
